import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  loginDetails: {},
  isLoading: false,
  error: "",
  hasData: false,
  codeStatus: "pending",
  successResponse: {},
  isLoadingAgency: false,
  errorAgency: "",
  hasDataAgency: false,
  codeStatusAgency: "pending",
  corporateSingupDetails: {}
};
const corporateLoginSlice = createSlice({
  name: "corporateLoginSection",
  initialState,
  reducers: {
    getCorporateLoginSectionDataPending: (state, action) => {
      state.isLoading = true;
      state.codeStatus = "pending";
    },
    getCorporateLoginSectionDataSuccess: (state, action) => {
      state.isLoading = false;
      state.error = "";
      state.hasData = true;
      state.loginDetails = action.payload;
      state.codeStatus = "success";
    },
    getCorporateLoginSectionDataFailure: (state, action) => {
      state.isLoading = false;
      state.codeStatus = "failure";
      state.error = action.payload;
    },
    resetCorporateLoginData: state => {
      state.codeStatus = "pending";
      state.error = "";
      state.loginDetails = {};
      state.hasData = false;
    },
    getAgencyLoginSectionDataPending: (state, action) => {
      state.isLoadingAgency = true;
      state.codeStatusAgency = "pending";
    },
    getAgencyLoginSectionDataSuccess: (state, action) => {
      state.isLoadingAgency = false;
      state.errorAgency = "";
      state.hasDataAgency = true;
      state.successResponse = action.payload;
      state.codeStatusAgency = "success";
    },
    getAgencyLoginSectionDataFailure: (state, action) => {
      state.isLoadingAgency = false;
      state.codeStatusAgency = "failure";
      state.errorAgency = action.payload;
    },
    resetAgencyLoginData: state => {
      state.codeStatusAgency = "pending";
      state.errorAgency = "";
      state.successResponse = {};
      state.hasDataAgency = false;
    },
    corporateSingupDataPending: (state, action) => {
      state.isLoading = true;
      state.codeStatus = "pending";
    },
    corporateSingupDataSuccess: (state, action) => {
      state.isLoading = false;
      state.error = "";
      state.hasData = true;
      state.corporateSingupDetails = action.payload;
      state.codeStatus = "success";
    },
    corporateSingupDataFailure: (state, action) => {
      state.isLoading = false;
      state.codeStatus = "failure";
      state.error = action.payload;
    },
    resetcorporatestatus: state => {
      state.codeStatus = "pending";
    }
  }
});
export const {
  getCorporateLoginSectionDataPending,
  getCorporateLoginSectionDataSuccess,
  getCorporateLoginSectionDataFailure,
  resetCorporateLoginData,
  getAgencyLoginSectionDataPending,
  getAgencyLoginSectionDataSuccess,
  getAgencyLoginSectionDataFailure,
  resetAgencyLoginData,
  corporateSingupDataPending,
  corporateSingupDataSuccess,
  corporateSingupDataFailure,
  resetcorporatestatus
} = corporateLoginSlice.actions;
export default corporateLoginSlice.reducer;